/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:28 GMT
 */
const tokens = {
    component: {
        stepper: {
            paddingHorizontal: {
                value: "12px",
                type: "dimension",
            },
            vertical: {
                paddingHorizontal: {
                    value: "0",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "12px",
                    type: "dimension",
                },
            },
            hover: {
                backgroundColor: {
                    value: "#294772",
                    type: "color",
                },
            },
            label: {
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                color: {
                    value: "#676767",
                    type: "color",
                },
                hover: {
                    backgroundColor: {
                        value: "#676767",
                        type: "color",
                    },
                },
                active: {
                    fontWeight: {
                        value: 600,
                        type: "fontWeight",
                    },
                    color: {
                        value: "#1e1e1e",
                        type: "color",
                    },
                },
            },
            icon: {
                backgroundColor: {
                    value: "#676767",
                    type: "color",
                },
                color: {
                    value: "#ffffff",
                    type: "color",
                },
                width: {
                    value: "24px",
                    type: "dimension",
                },
                height: {
                    value: "24px",
                    type: "dimension",
                },
                completed: {
                    backgroundColor: {
                        value: "#455D82",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#455D82",
                        type: "color",
                    },
                },
                text: {
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "fontWeight",
                    },
                },
            },
        },
    },
};
export default tokens;
